import { render } from "./index.vue?vue&type=template&id=fab350fe&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=fab350fe&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-fab350fe"

export default script